module.exports = __webpack_public_path__ + "static/Gotham-LightItalic-890c2b474dedeed25d313bb98ffeaa3f.ttf";